import React from "react";
import { FaSpinner } from "react-icons/fa";

/**
 * "İşlem sürüyor" rozeti (#303) — firmada kota/cihaz işlemi sürerken
 * (firma kilidi tutulurken) firmanın göründüğü her yerde gösterilir.
 * Durum `Hooks/dealerRoles/useFirmBusy` ile okunur.
 */
const FirmBusyBadge = ({ className = "" }) => (
  <span
    className={`inline-flex items-center gap-1 px-1.5 py-0.5 rounded-md bg-amber-50 text-amber-700 border border-amber-200 text-[10px] font-SemiBold whitespace-nowrap ${className}`}
    title="Bu firmada bir işlem sürüyor; bitene kadar kota ve cihaz işlemleri yapılamaz."
  >
    <FaSpinner className="w-2.5 h-2.5 animate-spin" />
    İşlem sürüyor
  </span>
);

export default FirmBusyBadge;
